interface ICardKeyListProps {
  cardKeyList: string[];
  activeKey: string;
  scrollToCard?: (item: string) => void;
}

export default function CardKeyList({
  cardKeyList,
  activeKey,
  scrollToCard,
}: ICardKeyListProps) {
  return (
    <div className="absolute right-0 w-4 h-20 top-0 bottom-0 my-auto flex flex-col items-center">
      {cardKeyList.map((item) => (
        <div
          key={item}
          className="w-4 h-4 flex items-center justify-center"
          onClick={() => scrollToCard && scrollToCard(item)}
        >
          <div
            className={`${
              activeKey === item ? "w-2.5 bg-mx-primary" : "w-1.5 bg-#CED2D9"
            } h-1 rounded-25`}
          />
        </div>
      ))}
    </div>
  );
}
